import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

function Edit() {
  const { escortId, reviewId } = useParams();
  const navigate = useNavigate();

  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");
  const [looks, setLooks] = useState(null);
  const [attitude, setAttitude] = useState("");
  const [value, setValue] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [message, setMessage] = useState("");

  // Get current user email from cookie
  const userCookie = Cookies.get("user");
  const currentUser = userCookie ? JSON.parse(userCookie) : null;
  const userEmail = currentUser?.email;

  // Fetch existing review data
  useEffect(() => {
    const fetchReview = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/${escortId}`);
        const data = await res.json();

        if (Array.isArray(data) && data.length > 0) {
          const escort = data[0];
          const review = escort.reviews?.find((r) => r.review_id === reviewId);

          if (review) {
            // Check if current user is the author
            if (review.user_email !== userEmail) {
              setMessage("❌ You are not authorized to edit this review.");
              return;
            }

            setRating(Number(review.rating));
            setComment(review.comment);
            setLooks(Number(review.looks));
            setAttitude(review.attitude);
            setValue(Number(review.value));
            setCharCount(review.comment?.length || 0);
          } else {
            setMessage("❌ Review not found.");
          }
        } else {
          setMessage("❌ Escort not found.");
        }
      } catch (err) {
        setMessage("❌ Failed to load existing review.");
        console.error(err);
      }
    };

    fetchReview();
  }, [escortId, reviewId, userEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const reviewData = {
      rating,
      comment,
      looks,
      attitude,
      value,
      user_email: userEmail, // 👈 send email to backend
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/review/${escortId}/${reviewId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reviewData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to update review.");
      }

      setMessage("✅ Review updated successfully!");

      // Optionally, redirect back to escort profile after a short delay
      setTimeout(() => {
        navigate(`/user/${escortId}`);
      }, 1000);
    } catch (error) {
      setMessage(`❌ ${error.message}`);
    }
  };

  return (
    <div
      style={{
        background: "#ffffff",
        maxWidth: "700px",
        margin: "30px auto",
        padding: "30px",
        borderRadius: "10px",
        border: "2px solid #1976d2",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        fontFamily: "Arial, sans-serif",
        color: "#0d47a1",
      }}
    >
      <h2
        style={{ marginBottom: "20px", color: "#1a237e", fontWeight: 600 }}
      >
        Edit Review
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Rating */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Rating (0–10):</strong></label><br />
          <select
            value={rating ?? ""}
            onChange={(e) => setRating(parseInt(e.target.value, 10))}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(11).keys()].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* Comment */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Comment (max 2000 characters):</strong></label><br />
          <textarea
            value={comment}
            onChange={(e) => {
              const text = e.target.value.slice(0, 2000);
              setComment(text);
              setCharCount(text.length);
            }}
            rows="5"
            required
            style={{
              width: "100%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              fontSize: "14px",
              resize: "vertical",
            }}
          />
          <div style={{ textAlign: "right", fontSize: "12px", color: "#444" }}>
            {charCount}/2000
          </div>
        </div>

        {/* Looks */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Looks (0–10):</strong></label><br />
          <select
            value={looks ?? ""}
            onChange={(e) => setLooks(parseInt(e.target.value, 10))}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(11).keys()].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* Attitude */}
        <div style={{ marginBottom: "15px" }}>
          <label><strong>Attitude:</strong></label><br />
          <select
            value={attitude}
            onChange={(e) => setAttitude(e.target.value)}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {["Very Bad","Bad","Average","Good","Very Good","Amazing"].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>

        {/* Value */}
        <div style={{ marginBottom: "20px" }}>
          <label><strong>Value (1–10):</strong></label><br />
          <select
            value={value ?? ""}
            onChange={(e) => setValue(parseInt(e.target.value, 10))}
            required
            style={selectStyle}
          >
            <option value="">Select</option>
            {[...Array(10).keys()].map((n) => (
              <option key={n + 1} value={n + 1}>{n + 1}</option>
            ))}
          </select>
        </div>

        {/* Submit */}
        <button
          type="submit"
          style={{
            backgroundColor: "#1976d2",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#115293")}
          onMouseLeave={(e) => (e.target.style.background = "#1976d2")}
        >
          Update Review
        </button>

        {/* Message */}
        {message && (
          <div
            style={{
              marginTop: "20px",
              color: message.startsWith("✅") ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}
      </form>
    </div>
  );
}

const selectStyle = {
  width: "100%",
  padding: "8px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
};

export default Edit;
